import {createRouter, createWebHashHistory} from 'vue-router';
import caminhoGlobal from "@/router/caminho-global";
// import {getTokenAuth, removeTokenAuth} from "@/stores/auth";

let rotaGlobal = new caminhoGlobal();
const routes = [
    {
        path: `${rotaGlobal.index}`,
        name: 'formulario',
        component: () => import('../components/formulario-ps-fisica.vue'),
        children: [
            {
                path: `${rotaGlobal.index}`,
                name: 'index_id',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/formulario-ps-fisica.vue'),
            },
            {
                path: `${rotaGlobal.index}editar-dados/pessoa-fisica`,
                name: 'index_idEdita',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/formulario-ps-fisica.vue'),
            }
        ]
    },
    {
        path: `${rotaGlobal.index_juridico}`,
        name: 'FomularioPsJuridica',
        component: () => import('../components/formulario-ps-juridica.vue'),
        children: [
            {
                path: `${rotaGlobal.index_juridico}`,
                name: 'PsJuridica_id',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/formulario-ps-juridica.vue'),
            },
            {
                path: `${rotaGlobal.index_juridico}editar-dados/pessoa-juridica`,
                name: 'PsJuridica_idEdita',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/formulario-ps-juridica.vue'),
            }
        ]
    },
    {
        path: `${rotaGlobal.codigo}`,
        name: 'codigo',
        component: () => import('../components/codigo-confirmacao.vue'),
        children: [
            {
                path: `${rotaGlobal.codigo}`,
                name: 'codigo_id',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/codigo-confirmacao.vue')
            }
        ]
    },
    {
        path: `${rotaGlobal.endereco}`,
        name: 'endereco',
        component: () => import('../components/endereco-formulario.vue'),
        children: [
            {
                path: `${rotaGlobal.endereco}/editar-dados`,
                name: 'endereco_idEdita',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/endereco-formulario.vue')
            },
            {
                path: `${rotaGlobal.endereco}`,
                name: 'endereco_id',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/endereco-formulario.vue')
            }
        ]
    },
    {
        path: `${rotaGlobal.documentos}`,
        name: 'documento',
        component: () => import('../components/anexar-documentos.vue'),
        children: [
            {
                path: `${rotaGlobal.documentos}`,
                name: 'documentos_id',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/anexar-documentos.vue')
            },
            {
                path: `${rotaGlobal.documentos}/editar-dados`,
                name: 'documentos_idEdita',
                prosp: true,
                // meta: {auth: true},
                component: () => import('../components/anexar-documentos.vue')
            }
        ]
    },
    {
        path: `${rotaGlobal.rota_erro_404}`,
        name: 'NaoExiste',
        component: () => import('../components/rota-nao-existe.vue'),
        children: [
            {
                path: `${rotaGlobal.index_error}/:pathMatch(.*)*/`,
                name: 'NaoExiste',
                component: () => import('../components/rota-nao-existe.vue'),
            }
        ]
    }
]

const router = createRouter({
    history: createWebHashHistory(process.env.BASE_URL),
    routes: routes
})
//
// router.beforeEach(async (to, from, next) => {
//     const token_Autenticado = await getTokenAuth();
//     if (to.matched.some(record => record.meta.auth)) {
//         if (!token_Autenticado) {
//             next({name: 'formulario'})
//             alert('Token Expired')
//             removeTokenAuth()
//         } else {
//             next()
//         }
//     } else {
//         next()
//     }
// });

export default router
